import {Component, inject} from '@angular/core';
import {
    DxButtonComponent,
    DxDataGridComponent, DxFormComponent,
    DxTemplateDirective
} from "devextreme-angular";
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoScrollingComponent,
    DxoSearchPanelComponent,
    DxoSortingComponent,
    DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {FilterConfig, GridPageComponent} from "../../common/grid-page.component";
import {AccessType, AssetType, AuthService, ChecklistCondition, ChecklistGridViewDto, PermissionType} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {UserAvatarEmailComponent} from "../../../components/utils/user-avatar-email/user-avatar-email.component";
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";
import {NgClass} from "@angular/common";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {Router} from "@angular/router";
import {AssetTypePipe} from "../../../pipes/asset-type.pipe";

@Component({
    selector: 'app-checklists',
    imports: [
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxButtonComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        UserAvatarEmailComponent,
        CapitalCasePipe,
        NgClass,
        FilterPanelComponent,
        DxFormComponent,
        AssetTypePipe
    ],
    providers: [AssetTypePipe],
    templateUrl: './checklists.component.html'
})
export class ChecklistsComponent extends GridPageComponent<ChecklistGridViewDto> {
    private router = inject(Router);
    private assetTypePipe = inject(AssetTypePipe);
    protected auth = inject(AuthService);

    dataSource = this.dataSources.checklists();
    protected override exportName: string = "Checklist";
    protected offset:number = 100;

    assetTypeOptions = EnumUtils.getEnumOptions(AssetType, (v) => this.assetTypePipe.transform(v));
    conditionOptions = EnumUtils.getEnumOptions(ChecklistCondition);

    constructor() {
        super();
        this.init(ChecklistGridViewDto);
    }

    protected override filterConfig: FilterConfig[] = [
        {field: 'number', op: 'contains'},
        {field: 'employee.name', op: 'contains', customFilter: this.nameOrEmailFilter},
        {field: 'machineNumber', op: 'contains'},
        {field: 'equipmentNumber', op: 'contains'},
        {field: 'assetType', op: '='},
        {field: 'condition', op: '='},
        {field: 'created', op: '>='},
    ];

    addChecklist = async () => {
        await this.router.navigate(['/checklist/create']);
    }

    async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
         await this.router.navigate([`/checklist/edit/${e.data.id}`]);
    }

    protected getBadgeClass(status: ChecklistCondition): string {
        switch (status) {
            case ChecklistCondition.Ok:
                return 'bg-success-subtle text-success';
            case ChecklistCondition.Defect:
                return 'bg-danger-subtle text-danger';
            case ChecklistCondition.Repaired:
                return 'bg-warning-subtle text-warning';
            default:
                return 'bg-info-subtle text-info';
        }
    }

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;
}
